import * as React from "react";
import { TemperatureUnitContext } from "../../context/app-context";
import textParser from "../../services/textParser";

export const TextAnswer = ({ text, index }) => {
    const [units] = React.useContext(TemperatureUnitContext);
    return (
        <p key={index} className="mb-6 leading-7 tracking-wide">
            {textParser({ text: text, units })}
        </p>
    );
};

export const TextQuestion = ({ text }) => {
    const [units] = React.useContext(TemperatureUnitContext);
    return (
        <h3 className="mt-12 mb-6 text-xl font-bold tracking-wide sm:text-2xl">
            {textParser({ text, units })}
        </h3>
    );
};

export const TextWrapper = ({ children }) => {
    return (
        <div className="justify m-auto w-10/12 xs:w-9/12 sm:w-8/12 md:w-6/12">
            {children}
        </div>
    );
};
